import { Badge, cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import {
  ORDER_LINE_TYPE_COPY,
  type OrderType,
} from "../../lib/order-line-kind";

const ORDER_TYPE_COPY: Record<OrderType, { key: string; fallback: string }> = {
  ...ORDER_LINE_TYPE_COPY,
  mixed: { key: "marketplace.orders.lineType.mixed", fallback: "Mixed" },
};

export function OrderTypeBadge({
  type,
  className,
}: {
  type: OrderType;
  className?: string;
}) {
  const { t } = useTranslation();
  const copy = ORDER_TYPE_COPY[type];
  return (
    <Badge
      variant="outline"
      className={cn(
        "text-caption border-border-subtle font-normal text-muted-foreground",
        className,
      )}
    >
      {t(copy.key, copy.fallback)}
    </Badge>
  );
}
